<template>
  <div>
    <van-popup v-model:show="show" position="bottom">
      <!-- datetime:【{{ datetime }}】currentDate:【{{ currentDate }}】 -->
      <van-datetime-picker
        v-model="datetime"
        @confirm="timeConfirm"
        @change="timechange"
        :filter="tiemFormatter"
        @cancel="timeCancel"
        type="time"
        title="选择预约时间"
      />
    </van-popup>
  </div>
</template>

<script>
import { reactive, toRefs, watch, ref, computed } from 'vue'
export default {
  props: {
    showPopUp: {
      default: 0,
      type: Number
    },
    currentDate: {
      default: '12:00',
      type: String
    },
    bookTimeArr: {
      default: () => [],
      type: Array
    }
  },

  setup(props, { emit }) {
    const { showPopUp, currentDate, bookTimeArr } = toRefs(props)
    const state = reactive({
      show: false,
      currentDate,
      showPopUp,
      datetime: currentDate,
      bookTimeArr
    })
    let bookTimeObj = computed(() => {
      let res = {}
      let len = state.bookTimeArr.length
      if (len) {
        for (let index = 0; index < len; index++) {
          const element = state.bookTimeArr[index]
          let key = element.slice(0, 2)
          if (res[key]) {
            res[key].push(element.slice(2))
          } else {
            res[key] = [element.slice(2)]
          }
        }
      }
      return res
    })
    let hourArr = computed(() => {
      // console.log('bookTimeObj.value', bookTimeObj.value)
      return Object.keys(bookTimeObj.value).sort() || []
    })
    let minuteArr = computed(() => {
      let hour = state.datetime.slice(0, 2)
      let res = bookTimeObj.value[hour] ? bookTimeObj.value[hour] : []
      // console.log('computed--minuteArr', bookTimeObj.value, hour, res)
      return res
    })
    watch(
      () => state.showPopUp,
      () => {
        state.show = true
        if (!state.datetime && state.bookTimeArr && state.bookTimeArr.length) {
          let first = state.bookTimeArr[0]
          let temp = `${first.slice(0, 2)}:${first.slice(2)}`
          state.datetime = ref(temp)
        }
      }
    )
    const timeConfirm = value => {
      emit('confirm', value)
      state.show = false
    }
    const timeCancel = () => {
      state.show = false
    }
    const tiemFormatter = (type, val) => {
      // console.log('tiemFormatter', type, val)
      if (type === 'hour') {
        return hourArr.value
      }
      if (type === 'minute') {
        return minuteArr.value
      }
      return val
    }
    const timechange = v => {
      let minute = v.slice(2)
      let hour = v.slice(0, 2)
      if (!minuteArr.value.includes(minute) && minuteArr.value.length === 1) {
        minute = minuteArr.value[0]
        let resetDate = `${hour}:${minute}`
        state.datetime = ref(resetDate)
      }
    }

    return {
      ...toRefs(state),
      timeConfirm,
      timeCancel,
      tiemFormatter,
      timechange,
      hourArr,
      minuteArr
    }
  }
}
</script>
